
import { Zap, Briefcase, Lock } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const BenefitsSection = () => {
  const { t } = useLanguage();
  
  const benefits = [
    {
      icon: Zap,
      title: t('benefits.faster.title'),
      description: t('benefits.faster.description')
    },
    {
      icon: Briefcase,
      title: t('benefits.workload.title'),
      description: t('benefits.workload.description')
    },
    {
      icon: Lock,
      title: t('benefits.secure.title'),
      description: t('benefits.secure.description')
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-[#F4F6F8] to-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center">
              <div className="mx-auto w-20 h-20 flex items-center justify-center mb-6">
                <benefit.icon className="w-16 h-16 text-[#1A237E]" />
              </div>
              <h3 className="text-xl font-semibold text-[#1A237E] mb-4">
                {benefit.title}
              </h3>
              <p className="text-[#0061A8]">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
